export enum ContentType {
  AUDIO = "AUDIO",
  BOOK = "BOOK",
  VIDEO = "VIDEO",
}
